<template>
  <div class="app-container">
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" border>
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column label="名称" prop="name" align="center" />
        <el-table-column label="是否启用" prop="enable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.enable" active-value="1" inactive-value="0" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleUpdate(scope)">编辑</el-button>
            <el-button type="text" style="color: #f56c6c" @click="handleDelete(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 新建/编辑表单 -->
    <follow-cust-record-type-add ref="followCustRecordTypeAdd" @created="doQueryList" :rowItem="rowItem" />
  </div>
</template>

<script>
import followCustRecordTypeAdd from './add'
import sysDataconstantApi from '@/api/config/sysDataconstant'

export default {
  components: {
    followCustRecordTypeAdd
  },
  data() {
    return {
      list: [],
      listLoading: true,
      rowItem: null
    }
  },
  created() {
    this.doQueryList()
  },
  methods: {
    /**
     * 执行列表查询
     */
    doQueryList() {
      this.listLoading = true
      return sysDataconstantApi.fetchCode({ code: 'addfollowCustRecordType' })
        .then(({ data }) => {
          this.rowItem = data
          this.list = data && data.content ? JSON.parse(data.content) : []
        })
        .catch((error) => {
          console.error('获取列表失败:', error)
          this.list = []
          this.rowItem = null
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 开关变化
     */
    changeSwitch(row) {
      let params = JSON.parse(JSON.stringify(this.rowItem))
      params.content = JSON.stringify(this.list)
      sysDataconstantApi.update(params).then(() => {
        this.$common.showMsg('success', '操作成功')
        return this.doQueryList()
      }).catch((error) => {
        console.error('更新失败:', error)
        this.$common.showMsg('error', '操作失败，请重试')
        // 如果更新失败，重新加载数据以恢复原值
        this.doQueryList()
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      if (!this.rowItem) {
        this.$common.showMsg('warning', '请先加载数据')
        return
      }
      this.$refs.followCustRecordTypeAdd.handleCreate()
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(scope) {
      if (!this.rowItem) {
        this.$common.showMsg('warning', '请先加载数据')
        return
      }
      this.$refs.followCustRecordTypeAdd.handleUpdate(scope)
    },
    /**
     * 删除
     */
    handleDelete(scope) {
      this.$common.confirm('确认删除该记录吗？').then(() => {
        let list = JSON.parse(JSON.stringify(this.list))
        list.splice(scope.$index, 1)
        let params = JSON.parse(JSON.stringify(this.rowItem))
        params.content = JSON.stringify(list)
        sysDataconstantApi.update(params).then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList()
        }).catch((error) => {
          console.error('删除失败:', error)
          this.$common.showMsg('error', '删除失败，请重试')
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.btn-right-side {
  display: flex;
  justify-content: flex-end;
}
</style>

